// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingDots_container__pIjnT","dot":"LoadingDots_dot__SjdE0","wave":"LoadingDots_wave__PgNfv"};